export default "data:image/webp;base64,UklGRj4AAABXRUJQVlA4TDIAAAAvJ4AGADATMEkYLvqDxvNbAg/CbKP5mwxuAPc6gmwbroEOZySHef8nQMjj7se7HPwfAA=="